import { McGroupedUpdateChildPayloadDto } from '../dtos/mc-grouped-update.payload.dto';

export { PROJECT_SHARED_METADATA_FIELDS } from '../models/survey-metadata.model';

// quotas/qualifications merge by qualification_code, not last-write-wins. completes_required is
// root's own sum of every child, not a duplicate-value candidate. never hoist any of these.
export const MC_GROUPED_UPDATE_HOIST_EXCEPTIONS: readonly (keyof McGroupedUpdateChildPayloadDto)[] =
  [
    'survey_id',
    'survey_localization',
    'quotas',
    'qualifications',
    'completes_required',
  ];

export const MC_MESSAGES = {
  NO_LOCALES_SELECTED: 'Please select at least one locale to save.',
  LOCALE_NOT_SAVEABLE: 'One of the selected locales cannot be saved yet.',
  NO_SIGNED_IN_USER: 'Your session has expired. Please sign in again to save.',
  NO_RESPONDENT_STATUS_SELECTED:
    'Select at least one respondent status from the list',
  UNIQUE_LINKS_NOT_UPLOADED:
    'Please upload Unique Buyer entry links to continue.',
  MANUAL_PROCESSING_IN_FLIGHT:
    'Please, click `Save and Process` before browsing to another Country/Locale.',
  LOCALE_DELETED: 'Survey removed and deleted successfully',
  DELETE_LOCALE_TITLE: 'DELETE DRAFT',
  DELETE_LOCALE_MESSAGE:
    'Do you want to remove and delete the survey from the configuration?',
  DELETE_LOCALE_CONFIRM: 'Yes, delete',
  DELETE_LOCALE_CANCEL: 'Cancel',
} as const;

export const MC_TRADITIONAL_MESSAGES = {
  SAVED: 'All surveys selected are saved as draft',
  REJECTED_SURVEYS: 'The system encountered a problem to create the survey for',
  LOCALE_ADDED: 'Success! New Survey Added',
} as const;

export const MC_GROUPED_MESSAGES = {
  SAVED: 'Success! The survey has been created.',
  CLONE_UNAVAILABLE:
    'CLONE a Multi-country Single Survey view is not available now. We will add this functionality soon.',
  TEMPLATE_UNAVAILABLE:
    'Template for Multi-country Single Survey view is not available now. You can continue to created template for Traditional Multi-country (Or Multi Survey) and Single survey',
  COMPLETES_REQUIRED: 'completes_required must be greater than 0',
} as const;

export const LOCALE_COMPLETES_MAX_VALUE = 99999;
